import fp from "lodash/fp";
import moment from "moment";

import { filtersConstants } from "./filters.constants";

const paidMonth = moment().format("MMMM YYYY");

const initialState = {
	agentOfficeReportsFilters: { paidMonth: paidMonth },
	agentReportsFilters: { paidMonth: paidMonth },
	internalReportsFilters: { paidMonth: paidMonth },
	withholdPaymentsFilters: { paidMonth: paidMonth },
	payoutsFilters: { paidMonth: paidMonth },
	unknownMidFilters: { paidMonth: paidMonth },
	missingScheduleAResidualFilter: { paidMonth: paidMonth },
	export: {},
};

export const getFilters = form => state => state.filters[form];
export const getIsExported = form => state => state.filters.export[form];

function getKeyValueActions(action) {
	return Object.entries<any>(action.filters).map(
		([multiKey, multiValue]) => ({
			...action,
			multiKey,
			multiValue,
		}),
	);
}

function reduceApplyMultiFilters(state, action) {
	const prevKeyState = state?.[action.form]?.[action.multiKey];
	if (!Array.isArray(prevKeyState)) {
		return {
			...state,
			[action.form]: {
				...state[action.form],
				[action.multiKey]: [action.multiValue],
			},
		};
	}

	const plainValueExists = prevKeyState.some(s => s === action.multiValue);

	const ddlValuesExists = ["id", "value"].some(
		checkField =>
			action.multiValue[checkField] !== undefined &&
			prevKeyState.some(
				s => s[checkField] === action.multiValue[checkField],
			),
	);

	if (plainValueExists || ddlValuesExists) {
		return state;
	}

	return {
		...state,
		[action.form]: {
			...state[action.form],
			[action.multiKey]: [...prevKeyState, action.multiValue],
		},
	};
}

function removeMultyKey(state, action) {
	let nextKeyState: any[] = [...(state?.[action.form]?.[action.key] || [])];

	if (action?.predicate) {
		nextKeyState = nextKeyState.filter(action?.predicate);
	} else {
		nextKeyState.splice(action.index, 1);
	}

	if (nextKeyState.length === 0) {
		const path = `${action.form}.${action.key}`;
		return fp.unset(path, state);
	} else {
		return {
			...state,
			[action.form]: {
				...state[action.form],
				[action.key]: nextKeyState,
			},
		};
	}
}

function reduceApplyFilters(state, action) {
	const isMultiValue = action?.columns?.some(x => {
		if (x.name === action.multiKey) {
			return x.isMultiValue;
		} else {
			return false;
		}
	});

	if (!isMultiValue) {
		return {
			...state,
			[action.form]: {
				...state[action?.form],
				[action.multiKey]: action?.multiValue,
			},
		};
	} else {
		return reduceApplyMultiFilters(state, action);
	}
}

function filters(state = initialState, action) {
	switch (action.type) {
		case filtersConstants.SET_IS_EXPORTED: {
			return {
				...state,
				export: {
					...action.export,
					[action.form]: action.isExported,
				},
			};
		}
		case filtersConstants.APPLY_FILTERS: {
			return getKeyValueActions(action).reduce(reduceApplyFilters, state);
		}

		case filtersConstants.RESET_FILTERS: {
			const resetFilters = filters => {
				const resetFilters = { ...filters };
				Object.keys(resetFilters).forEach(key => {
					action.excludedLabels?.includes(key) ||
						delete resetFilters[key];
				});

				return resetFilters;
			};

			return {
				...state,
				[action.form]: resetFilters(state[action.form]),
			};
		}
		case filtersConstants.REMOVE_KEY: {
			const isMultiValue = action?.columns.some(x => {
				if (x.name === action.key) {
					return x.isMultiValue;
				} else {
					return false;
				}
			});

			if (isMultiValue) {
				return removeMultyKey(state, action);
			} else {
				const path = `${action.form}.${action.key}`;
				return fp.unset(path, state);
			}
		}
		default: {
			return state;
		}
	}
}

export default filters;
